import * as types from './types';
//import { UserInfo, UserRole } from '../../Login/common/defaults';
//import { SearchResult } from '../Parts/SearchResult';

interface IEasyQueryState {
	easyQueryXml: any;
	easyQuerySearchResults: any;
	errors: string[];
	query: string;
	queryList: any;
}

const initialEasyQueryState = {
	easyQueryXml: '',
	easyQuerySearchResults: [],
	errors: undefined,
	query: '',
	queryList: []
};

export default (state: IEasyQueryState = initialEasyQueryState, action: any) => {
	let _state = { ...state };
	switch (action.type) {
		case types.LOAD_EASY_QUERY_XML_INTO_STORE:
			_state = {
				..._state,
				easyQueryXml: action.value
			};
			return _state;
		case types.LOAD_QUERY_LIST_INTO_STORE:
			_state = {
				..._state,
				queryList: action.value
			};
			return _state;
		case types.LOAD_EASY_QUERY_SEARCH_RESULTS_INTO_STORE:
			_state = {
				..._state,
				easyQuerySearchResults: action.value
			};
			return _state;
		case types.LOAD_EASY_QUERY_ERRORS_INTO_STORE:
			_state = {
				...state,
				errors: action.value
			};
			return _state;
		case types.LOAD_SQL_QUERY_INTO_STORE:
			_state = {
				...state,
				query: action.value
			}
			return _state;
		default:
			return _state;
	}
};
